// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".web-view_4d83 {\n  border: none;\n  flex-grow: 1;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/Observe/FullscreenLayout.scss","FullscreenLayout.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,YAAA;ACCJ","file":"FullscreenLayout.scss","sourcesContent":[".web-view {\n    border: none;\n    flex-grow: 1;\n}\n",".web-view {\n  border: none;\n  flex-grow: 1;\n}"]}]);
// Exports
exports.locals = {
	"web-view": "web-view_4d83"
};
module.exports = exports;
